import BlogInfo from "../Components/BlogInfo";

export default function Show() {
  return (
    <div>
      <BlogInfo />
    </div>
  )
}
